import { createFileRoute } from "@tanstack/react-router";
import { Button } from "../../Components/ui/Button";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../Components/ui/Form";
import { Input } from "../../Components/ui/Input";
import { Days, TripFormSchema } from "../../Types/Trip";

import RoutePlanner from "../../Components/Create/RoutePlanner";
import { TimePicker } from "../../Components/ui/TimePicker";

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../Components/ui/DDMenu";
import { CreatePBTrip } from "../../lib/PB/Trips";

export const Route = createFileRoute("/Trips/Create")({
  component: CreateTrip,
});

export default function CreateTrip() {
  const form = useForm<z.infer<typeof TripFormSchema>>({
    resolver: zodResolver(TripFormSchema),
    defaultValues: {},
  });
  const { formState, setValue } = form;

  function onSubmit(values: z.infer<typeof TripFormSchema>) {
    // Do something with the form values.
    // ✅ This will be type-safe and validated.
    console.log("V: ", values);
    CreatePBTrip(values).then((id) => console.log("trip id: ", id));
  }
  console.log("err", formState.errors);

  return (
    <div className="container mx-auto px-4">
      CreateTrip
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-8 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
        >
          <FormField
            control={form.control}
            name="title"
            render={({ field }) => (
              <FormItem className="flex items-center gap-3">
                <FormLabel>Title</FormLabel>
                <FormControl>
                  <Input placeholder="title" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="maxSubscribers"
            render={({ field }) => (
              <FormItem className="flex items-center gap-3">
                <FormLabel>Max Number Of Subscribers</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="max number of subscribers"
                    {...field}
                    onChange={(e) => {
                      setValue("maxSubscribers", Number(e.currentTarget.value));
                    }}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="departAt"
            render={({ field }) => {
              const hours = field.value?.getHours();
              const minutes = field.value?.getMinutes();
              const formattedTime = `${hours?.toString().padStart(2, "0")}:${minutes?.toString().padStart(2, "0")}`;
              return (
                <FormItem className="flex items-center gap-3">
                  <FormLabel>Departe At</FormLabel>
                  <FormControl>
                    <TimePicker
                      {...field}
                      value={formattedTime}
                      onChange={(e) => {
                        const [hours, minutes] =
                          e.currentTarget.value.split(":");
                        let dateObject = new Date();
                        dateObject.setHours(Number(hours));
                        dateObject.setMinutes(Number(minutes));
                        setValue("departAt", dateObject);
                      }}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <FormField
            control={form.control}
            name="arriveAt"
            render={({ field }) => {
              const hours = field.value?.getHours();
              const minutes = field.value?.getMinutes();
              const formattedTime = `${hours?.toString().padStart(2, "0")}:${minutes?.toString().padStart(2, "0")}`;
              return (
                <FormItem className="flex items-center gap-3">
                  <FormLabel>Arrive At</FormLabel>
                  <FormControl>
                    <TimePicker
                      {...field}
                      value={formattedTime}
                      onChange={(e) => {
                        const [hours, minutes] =
                          e.currentTarget.value.split(":");
                        let dateObject = new Date();
                        dateObject.setHours(Number(hours));
                        dateObject.setMinutes(Number(minutes));
                        setValue("arriveAt", dateObject);
                      }}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <FormField
            control={form.control}
            name="days"
            render={({ field }) => {
              console.log(field);
              return (
                <div>
                  <FormItem className="flex items-center xl:gap-44 lg:gap-44 sm:gap-7 md:gap-7">
                    <FormLabel> Repeating Days</FormLabel>
                    <FormControl>
                      <DropdownMenu {...field}>
                        <DropdownMenuTrigger>
                          <Button variant="outline">
                            Select Repeating Days
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="w-56">
                          <DropdownMenuLabel>Repeating Days</DropdownMenuLabel>
                          <DropdownMenuSeparator />
                          {Object.keys(Days).map((day: string) => {
                            return (
                              <DropdownMenuCheckboxItem
                                checked={!!field.value?.find((d) => d === day)}
                                onCheckedChange={(c: boolean) => {
                                  console.log(c);
                                  const newVal = field.value
                                    ? [...field.value]
                                    : [];
                                  if (c) {
                                    //@ts-ignore
                                    newVal.push(day);
                                  } else {
                                    const dayIndex = newVal.findIndex(
                                      (d) => d === day
                                    );
                                    if (dayIndex > -1)
                                      newVal.splice(dayIndex, 1);
                                  }
                                  setValue("days", newVal);
                                }}
                                onSelect={(e) => e.preventDefault()}
                              >
                                {day}
                              </DropdownMenuCheckboxItem>
                            );
                          })}
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                </div>
              );
            }}
          />
          <RoutePlanner
            form={form}
            defaultFieldObject={{
              title: "",
              lat: 0,
              lon: 0,
              address: "",
              index: -1,
            }}
          />
          <div>
            <Button type="submit" variant={"default"} className="m-5">
              Submit
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
